import React from "react";
import { Navigate } from "react-router-dom";

// Auth
import Logout from "../admin/components/Authentication/Logout";
import ForgetPasswordPage from "../admin/components/Authentication/ForgetPassword";
import ResetPassword from "../admin/components/Authentication/ResetPassword";
import VerifyEmail from "../admin/components/Authentication/VerifyEmail";
import Register from "../admin/components/Authentication/Register";
import OwnerLogin from "../admin/components/Owner/OwnerLogin";

// Comuns
import Profile from "../admin/components/profile/Profile";
import Error from "../admin/components/error404";
import Unauthorized from "../admin/components/unauthorized";
import ErrorPage from "../admin/components/error500";

// Oplena — clientes, boletos, help desk
import OplenaDashboard from "../admin/components/Oplena/OplenaDashboard";
import Clientes from "../admin/components/Oplena/Clientes";
import Contatos from "../admin/components/Oplena/Contatos";
import Boletos from "../admin/components/Oplena/Boletos";
import HelpDesk from "../admin/components/Oplena/HelpDesk";

const ANY = ["admin", "support"];

const authProtectedRoutes = [
    { path: "/admin", component: <OplenaDashboard />, allowedRoles: ANY },
    { path: "/admin/dashboard", component: <OplenaDashboard />, allowedRoles: ANY },
    { path: "/admin/clientes", component: <Clientes />, allowedRoles: ANY },
    { path: "/admin/contatos", component: <Contatos />, allowedRoles: ANY },
    { path: "/admin/boletos", component: <Boletos />, allowedRoles: ANY },
    { path: "/admin/helpdesk", component: <HelpDesk />, allowedRoles: ANY },
    { path: "/admin/profile", component: <Profile />, allowedRoles: ANY },

    // Errors
    { path: "/admin/404", component: <Error /> },
    { path: "/admin/unauthorized", component: <Unauthorized /> },
    { path: "/admin/500", component: <ErrorPage /> },
    { path: "/admin/*", component: <Error /> },
];

const publicRoutes = [
    { path: "/", component: <Navigate to="/login" replace /> },
    { path: "/login", component: <OwnerLogin /> },
    { path: "/logout", component: <Logout /> },
    { path: "/forgot-password", component: <ForgetPasswordPage /> },
    { path: "/reset-password", component: <ResetPassword /> },
    { path: "/verify-email", component: <VerifyEmail /> },
    { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };
